import { API_BASE_URL } from '../../../api';
import React, { useState, useContext, useEffect } from 'react';
import RobCalendar from '../RobCalendar/robCalendar.component';
import { AccountContext } from '../../../Contexts/main.context';

const CreateFollowUp = ({ currentDateValue, setCurrentDate, closeModal, defaultTitle = '', defaultMessage = '' }) => {
     const { myAccount, userAccounts, updateFollowUpArray } = useContext(AccountContext);
     const [assignTo, setAssignTo] = useState([]);
     const [title, setTitle] = useState(defaultTitle);
     const [note, setNote] = useState(defaultMessage);

     useEffect(() => {
          setAssignTo(myAccount.ID);
          console.log(`Initial Set to: ${myAccount.ID}`);
     }, [myAccount]);

     useEffect(() => {
          setTitle(defaultTitle);
          setNote(defaultMessage);
     }, [defaultTitle, defaultMessage]);
     

     const letsSaveReminder = async () => {
          const sendData = {
               clientID: myAccount.ID,
               date: currentDateValue,
               title: title,
               note: note,
               assignTo: assignTo,
               script: "createFollowUp",
          };
          try {
               const response = await fetch(API_BASE_URL + 'special.php', {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(sendData),
               });

               const data = await response.json();
               updateFollowUpArray(data);
               closeModal();
          }
          catch (error) {
               alert("Error Creating Follow Up");
          }
     }

     return (
          <>
               <div
                    className="modal d-flex justify-content-center align-items-center"
                    style={{
                         position: "fixed",
                         top: 0,
                         left: 0,
                         height: "100vh",
                         width: "100vw",
                         backgroundColor: "rgba(0, 0, 0, 0.5)",
                         zIndex: 2000,
                    }}
               >
                    <div
                         className="modal-dialog"
                         style={{
                              zIndex: 2001,
                              width: "50%",
                              maxWidth: "none",
                              minWidth: "300px",
                         }}
                    >
                         <div className="modal-content shadow p-4 bg-white rounded">
                              <div className="modal-header">
                                   <h5 className="modal-title">Create Follow-Up</h5>
                                   <button type="button" className="btn-close" onClick={closeModal}></button>
                              </div>

                              <div className="modal-body">
                                   <div className="mb-3">
                                        <label className="form-label">Date</label>
                                        <RobCalendar
                                             dateIn={currentDateValue}
                                             onDateChange={(date) => setCurrentDate(date)}
                                        />
                                   </div>
                                   <div className="mb-3">
                                        <label className="form-label">Assign To</label>
                                        <select
                                             className="form-select"
                                             value={assignTo}
                                             onChange={(e) => setAssignTo(e.target.value)} // Replace with your handler if needed
                                        >
                                             {userAccounts.map((account) => (
                                                  <option key={account.ID} value={account.ID}>
                                                       {account.displayName}
                                                  </option>

                                             ))}
                                        </select>
                                   </div>

                                   <div className="mb-3">
                                        <label className="form-label">Title</label>
                                        <input
                                             type="text"
                                             className="form-control"
                                             placeholder="Enter title"
                                             value={title}
                                             onChange={(e) => setTitle(e.target.value)}
                                        />
                                   </div>

                                   <div className="mb-3">
                                        <label className="form-label">Note</label>
                                        <textarea
                                             className="form-control"
                                             rows="4"
                                             placeholder="Enter note"
                                             value={note}
                                             onChange={(e) => setNote(e.target.value)}
                                        />
                                   </div>
                              </div>

                              <div className="modal-footer">
                                   <button className="btn btn-secondary" onClick={closeModal}>
                                        Cancel
                                   </button>
                                   <button className="btn btn-primary" onClick={() => letsSaveReminder()}>Submit</button>
                              </div>
                         </div>
                    </div>
               </div>
          </>
     );
};

export default CreateFollowUp;
